import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com';

if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true, // enables automatic event capture (clicks, pageviews, etc.)
    capture_pageview: true,
    // debug: true, // Uncomment for debugging
  });
} else {
  // eslint-disable-next-line no-console
  console.warn('PostHog key is missing. Analytics will not be initialized.');
}

/**
 * Capture a custom event with PostHog.
 * @param eventName The name of the event (e.g., 'session_start', 'mouse_hover')
 * @param properties Additional properties to send with the event
 */
export function captureEvent(eventName: string, properties: Record<string, unknown> = {}) {
  if (POSTHOG_KEY) {
    // Debug log to verify event sending
    // eslint-disable-next-line no-console
    console.log('[PostHog] captureEvent:', eventName, properties);
    posthog.capture(eventName, properties);
  }
}

export default posthog;
